module.exports = __webpack_public_path__ + "static/img/linea_800.c0c9c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linea_800.png
// module id = 0KcV
// module chunks = 9